import { RootState } from '@reducers';

export const selectCarPolicyRenewal = (state: RootState) => state.userDashboardReducer.policyRenewalReducer.carPolicyRenewalReducer;
